import { EXTRA_SMALL, EXTRA_EXTRA_SMALL, SMALL, MEDIUM } from '../../constants/sizes';
export const ICON_BUTTON_SIZE_TO_ICON_SIZE = {
  [EXTRA_SMALL]: EXTRA_EXTRA_SMALL,
  [SMALL]: EXTRA_SMALL,
  [MEDIUM]: SMALL
};